import * as React from "react";
import { cs } from "../../core/classSet";
import styles from "./Heading.module.css";

type IHeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface IHeadingProps extends React.HTMLProps<HTMLHeadingElement> {
  bold?: boolean;
  component: IHeadingType;
  variant: IHeadingType;
}

const headingClassMap = {
  h1: styles.heading1,
  h2: styles.heading2,
  h3: styles.heading3,
  h4: styles.heading4,
  h5: styles.heading5,
  h6: styles.heading6,
};

/**
 * The component prop controls which HTML element is output, the variant prop controls its appearance
 */

export default function Heading({
  bold = true,
  className,
  component: Component,
  variant,
  ...otherProps
}: IHeadingProps) {
  return (
    <Component
      {...otherProps}
      className={cs(headingClassMap[variant], [styles.bold, bold], className)}
    />
  );
}
